export default "__VITE_ASSET__Dbaco8BK__"